import { useEffect, useState } from "react";
import { _Countries } from "../../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { BasicTable } from "../../../../../../../modules/theme/Component/BasicTable";
import { Modal } from "../../../../../../../modules/theme/Component/Modal";
import { toast } from "react-toastify";
import usePaginator from "../../../../../../../modules/theme/Component/usePaginator";
import { BasicButton } from "../../../../../../../modules/theme/Component/BasicButton";

interface Props {
    label?: string;
    onChange: Function;
    idSelector: number;
}

interface Search {
    Code: string;
    Name: string;
}

export const CountryEditor = ({ onChange, label, idSelector }: Props) => {

    const { lista, setLista, instance, bean, setBean } = useDataBean(_Countries);
    const paginador = usePaginator();
    const [valor, setValor] = useState<string>("");
    const [response, setResponse] = useState<Search>({
        Code: "Col",
        Name: "Colombia"
    })
    const [modal, setModal] = useState<any>({ name: 'Paises', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        if (idSelector) {
            instance.getCountrieByID(idSelector).then(
                (resp) => {
                    onChange(resp)
                    setValor(`${resp.Iso3} - ${resp.Name}`)
                }
            ).catch(
                err => { toast.error(err) }
            )
        }
    }, [idSelector])


    useEffect(() => {
        getLista();
    }, [paginador.page])

    const returnData = () => {
        if (!bean.IDCountries) {
            toast.error("Pais no valido")
        } else {
            setValor(`${bean.Iso3} - ${bean.NameCountry}`)
            if (onChange) {
                onChange(bean);
            }
            setModal({ ...modal, view: false });
        }
    }

    const getLista = () => {
        const props = {
            NameCountry: response.Name,
            Iso3: response.Code
        }
        instance.gerCountryRender(paginador.page, 15, props).then(
            (resp: any) => {
                setLista(resp.List)
                paginador.setPages(resp.NumberOfPages);
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const head = [
        { title: 'ID', property: 'IDCountries', visible: true },
        { title: 'Codigo', property: 'Iso3', visible: true },
        { title: 'Pais', property: 'NameCountry', visible: true },
    ]


    return (
        <>

            <label>{label ?? "Pais"}</label>
            <div className="form-control text-wrap" style={{ minHeight: '35px' }} onClick={() => setModal({ ...modal, "view": true })}>
                {valor ? (
                    valor
                ) : (
                    <span>Seleccionar...</span>
                )}
            </div>

            <Modal onSubmitLabel='Seleccionar' modal={modal} updateModal={setModal} eventModal={() => { returnData() }}>
                <div className="row">
                    <div className="col-md-5">
                        <label >Codigo</label>
                        <input type="text" className="form-control" value={response.Code} onChange={(e) => { setResponse({ ...response, Code: e.target.value }) }} />
                    </div>
                    <div className="col-md-5">
                        <label >Nombre</label>
                        <input type="text" className="form-control" value={response.Name} onChange={(e) => { setResponse({ ...response, Name: e.target.value }) }} />
                    </div>
                    <div className="col-md-2 mt-4">
                        <BasicButton eventClick={getLista} icon="ri-search-line" children={`Buscar`} />
                    </div>
                    <div className="col-md-12">
                        <BasicTable
                            body={lista}
                            head={head}
                            rowSet={setBean}
                            pageTop={paginador.page}
                            next={paginador.next}
                            back={paginador.back}
                            records={paginador}
                        />
                    </div>
                </div>
            </Modal>
        </>
    )
}